import { render, staticRenderFns } from "./FormChoice.vue?vue&type=template&id=a4a76bae&scoped=true"
import script from "./FormChoice.vue?vue&type=script&lang=js"
export * from "./FormChoice.vue?vue&type=script&lang=js"
import style0 from "./FormChoice.vue?vue&type=style&index=0&id=a4a76bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a76bae",
  null
  
)

export default component.exports